import { render, staticRenderFns } from "./Ready.vue?vue&type=template&id=fd511506&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd511506')) {
      api.createRecord('fd511506', component.options)
    } else {
      api.reload('fd511506', component.options)
    }
    module.hot.accept("./Ready.vue?vue&type=template&id=fd511506&", function () {
      api.rerender('fd511506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/serviceStatus/Ready.vue"
export default component.exports